import { lazy } from 'react';

const TopPerformer = lazy(() =>
  import(/* webpackChunkName: "top-performer" */ './TopPerformer'));

export default TopPerformer;
